import React, { useRef, useState, useEffect } from "react"
import { useTranslation } from 'react-i18next';


import { useHookStore } from "../../../hook-store/store"
// import { resizeImageFile } from '../../utils/image/image-utils';
import { marks } from '../../../utils/marks';

import "./DiffusionOptionsDesc.css";

// import IpaImage1 from "../../../image/for-iopaint/option-description/ipa/ipa-input-h100.jpeg";
// import IpaImage2 from "../../../image/for-iopaint/image-prompt/statue-h200.png";
// import IpaImage3 from "../../../image/for-iopaint/option-description/ipa/ipa-mask-h100.jpeg";
// import IpaImage4 from "../../../image/for-iopaint/option-description/ipa/ipa-output-h100.jpg";

import IpaInputImage2 from '../../../image/for-iopaint/image-prompt/boy-man-h200.png';
import IpaMaskImage2 from '../../../image/for-iopaint/image-prompt/boy-man-ipa-mask-h200.png';

import IpaResultStrength1 from '../../../image/for-iopaint/image-prompt/boy-man-ipa-str0.4-h150.png';
import IpaResultStrength2 from '../../../image/for-iopaint/image-prompt/boy-man-ipa-str0.6-h150.png';
import IpaResultStrength3 from '../../../image/for-iopaint/image-prompt/boy-man-ipa-str0.8-h150.png';


function DiffusionOptionsDescStrength() {
    
    const [t] = useTranslation('translation');
  
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [hStore, hDispatch] = useHookStore();
    const { 
      // inputEta
    } = hStore.iopaintStore;

    return (
      <div className="diffsionOptionDesc">
        <div className="diffsionOptionDescRow">
          {t('diffusionOptions24', 'This input control image diversity of output image.')}        
          <br/>
          {t('diffusionOptions25', 'When higher input value is used, more diverse images are generated based on other input values.')} 
          {' '}{t('diffusionOptions26', 'When lower value is used, less diverse and similar to input images are generated.')} 
        </div>
        <div className="diffsionOptionDescRow">
          <div className="diffsionOptionDescImages">
            <div>
              <img className="diffsionOptionDescImage"
                src={IpaInputImage2}
              />
              input
            </div>
            <div>
              <img className="diffsionOptionDescImage"
                src={IpaMaskImage2}
              />
              Selected
            </div>
          </div>
        </div>
        <div className="diffsionOptionDescRow">
          <div className="diffsionOptionDescImages">
            <div>
              <img className="diffsionOptionDescImage"
                src={IpaResultStrength1}
              />
              0.4
            </div>
            <div>
              <img className="diffsionOptionDescImage"
                src={IpaResultStrength2}
              />
              0.6
            </div>
            <div>
              <img className="diffsionOptionDescImage"
                src={IpaResultStrength3}
              />
              0.8
            </div>
          </div>
        </div>
      </div>
    )
  }


export default DiffusionOptionsDescStrength;